// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"SubtitleCopy_subtitle__1Em-c multilang-support"};